/**
 * Builder's one way of writing a day for people: "Oct 20, 2026" (en-US, the
 * format the survey lists use). Pure. Takes an ISO day (`2026-10-20`) or a full
 * ISO timestamp; anything unreadable comes back as given, never as "Invalid Date".
 */
const DAY = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
});

export function formatDay(iso: string | null | undefined): string {
    if (!iso) return '';
    const day = /^\d{4}-\d{2}-\d{2}$/.test(iso) ? `${iso}T00:00:00Z` : iso;
    const t = Date.parse(day);
    return Number.isNaN(t) ? iso : DAY.format(new Date(t));
}

/** `2026-10-20` plus whole days, as an ISO day. */
export function addDays(isoDay: string, days: number): string {
    const t = Date.parse(`${isoDay}T00:00:00Z`);
    return new Date(t + days * 86_400_000).toISOString().slice(0, 10);
}
